import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import {
    GridComponent,
    ColumnsDirective,
    ColumnDirective,
    Page,
    Sort,
    Inject,
} from "@syncfusion/ej2-react-grids";
import Loader from "components/blocks/Loader/Loader";
import useGetDeclaracionSituacionActividadByID from "services/record/DeclaracionSituacionActividad.tsx/useGetDeclaracionSituacionActividadItByID";
import useGetInfoDeclaracionSituacionActividadIt from "services/record/DeclaracionSituacionActividad.tsx/useGetInfoDeclaracionSituacionActividadIt";
import useGetDeclaracionSituacionActividadItByUser from "services/record/DeclaracionSituacionActividad.tsx/useGetDeclaracionSituacionActividadItByUser";
import DeclaracionSituacionActividad from "./DeclaracionSituacionActividad";
import { set } from "react-hook-form";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorDisplay";

const GridDeclaracionSituacionActividad = () => {
    const { getInfoDeclaracionSituacionActividadIt } = useGetInfoDeclaracionSituacionActividadIt()
    const { getDeclaracionSituacionActividadItByUser, dataGetDeclaracionSituacionActividadItByUser, loadingGetDeclaracionSituacionActividadItByUser, successGetDeclaracionSituacionActividadItByUser } = useGetDeclaracionSituacionActividadItByUser()

    const title = 'Declaracion Situación Actividad'
    const history = useHistory();
    const tokenResponse = useDecode("token");
    const userId = tokenResponse && tokenResponse.extension_id;
    const [arrData, setArrData] = useState(null)
    const [dataUser, setDataUser] = useState(null);
    // const [loadInfo, setLoadInfo] = useState('')
    const [info, setInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(false);
    const [sortingOptions] = useState({
        columns: [{ field: "created", direction: "Descending" }],
    });
    let pageOptions = {
        pageSize: 10,
        pageSizes: ["5", "10", "15", "20", "Todos"],
    };
    const rowSelected = (args) => {
        setInfo(false)
        setLoading(true)
        setShow(false)
        setTimeout(() => {
            setShow(true)
            setLoading(false)

        }, 200);
        const selectedData = args.data;
        setDataUser(selectedData);

    };
    useEffect(() => {
        getDeclaracionSituacionActividadItByUser(userId);
    }, [])

    useEffect(() => {
        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            console.log(hasFormZero)
            setShowGenerateButton(!hasFormZero);
        }
    }, [arrData]);

    const handleGetInfoDirectPaymentFormIt = () => {
        setLoading(true)
        setInfo(true)
        getInfoDeclaracionSituacionActividadIt(userId, setDataUser)
        if (dataUser) {
            //console.log(dataUser)
            setTimeout(() => {
                setLoading(false)
                //setLoadInfo('endProcces')
            }, 200)
        }
    }

    useEffect(() => {
        setLoading(true)
        setShow(false)
        setTimeout(() => {
            setShow(true)
            setLoading(false)
        }, 200);
    }, [dataUser]);

    useEffect(() => {
        if (successGetDeclaracionSituacionActividadItByUser) {
            setArrData(dataGetDeclaracionSituacionActividadItByUser);
        }
    }, [dataGetDeclaracionSituacionActividadItByUser]);

    return (
        <div className="container bg-#EEEEEE">
            <PageMenu title={title} >
                <div className="btns-header-container">
                    <button onClick={() => history.goBack()}>
                        <img src={IconArrowGray} alt="icon arrow right" />
                    </button>
                </div>
            </PageMenu>
            <GridComponent
                dataSource={arrData && arrData}
                allowPaging={true}
                allowSorting={true}
                rowSelected={rowSelected}
                pageSettings={pageOptions}
                //sortSettings={sortingOptions}
                enablePersistence={false}
            >
                <ColumnsDirective>
                    <ColumnDirective
                        field="CodigoExpediente"
                        headerText="Expediente"
                        width="100"
                        textAlign="Center"
                    />
                    <ColumnDirective
                        field="EstadoFormularioDescripcion"
                        headerText="Estado"
                        width="100"
                        textAlign="Center"
                    />
                    <ColumnDirective
                        field="FechaAceptacionSolicitud"
                        headerText="Fecha Solicitado"
                        type="date"
                        format="dd/MM/yyyy"
                        width="100"
                    />
                </ColumnsDirective>
                <Inject services={[Page, Sort]} />
            </GridComponent>
            {showGenerateButton && (
                <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={() => handleGetInfoDirectPaymentFormIt()}>
                        Generar Formulario
                    </button>
                </div>
            )}

            <Loader activeLoader={loading} label="Cargando Formulario"></Loader>
            {dataUser && (dataUser?.BoolResultado !== false) && show && (
                <div className="mt-5">
                    <DeclaracionSituacionActividad dataUser={dataUser} info={info} />
                </div>
            )}

            {dataUser && show && dataUser?.BoolResultado === false && (
                <ErrorDisplay descripcionError={dataUser.Descripcion} />
            )}

        </div>
    );
};
export default GridDeclaracionSituacionActividad;
